import { render, staticRenderFns } from "./PaymentHub.vue?vue&type=template&id=1c104b92&scoped=true"
import script from "./PaymentHub.vue?vue&type=script&lang=js"
export * from "./PaymentHub.vue?vue&type=script&lang=js"
import style0 from "./PaymentHub.vue?vue&type=style&index=0&id=1c104b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c104b92",
  null
  
)

export default component.exports